import { Link, useLocation } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();
  useDocumentMeta("页面不存在 - 午夜影院");

  return (
    <div className="flex w-full items-center justify-center bg-background-50 px-4 py-20 md:py-28">
      <div className="w-full max-w-xl rounded-lg border border-background-200 bg-background-100 p-8 text-center md:p-12">
        <p className="font-heading text-5xl font-semibold tracking-tight text-primary-900">404</p>
        <h1 className="mt-4 font-heading text-xl font-semibold text-foreground-950">
          这个页面不在放映计划里
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-foreground-500">
          你访问的地址可能已经调整。可以回到首页，或从分类页继续浏览影视作品。
        </p>
        <p className="mt-3 font-label text-[11px] text-foreground-400">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-900 px-4 py-2.5 text-sm text-background-50 transition-colors duration-300 hover:bg-primary-800"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors duration-300 hover:border-accent-400 hover:text-accent-700"
          >
            浏览电影分类
          </Link>
        </div>
      </div>
    </div>
  );
}